import { render } from "./couponCenter.vue?vue&type=template&id=0b83df40"
import script from "./couponCenter.vue?vue&type=script&lang=js"
export * from "./couponCenter.vue?vue&type=script&lang=js"

import "./couponCenter.vue?vue&type=style&index=0&id=0b83df40&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__